import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import EventEmitter from './EventEmitter.js'
import {gsap} from 'gsap'


export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.sources = sources

        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        

        this.pl = gsap.timeline({ paused: true, onStart:() => {
            gsap.set(".experience", {opacity:1})
            gsap.to('.initialContainer', {opacity: 0, onComplete: () => {
                document.querySelector('.initialContainer').style.display = "none"
            }})
        }})
        .from(".preload_loader", { drawSVG: '0%', ease:'linear', duration:1 })
        .to("#preloadrect", {motionPath:{
        path:'#preloadpath',
        align : "#preloadpath",
        alignOrigin: [0.5, 0.5],
        autoRotate: true,
        start:0,
        end: 0.5
        }, duration:1, ease:'linear', onComplete:() => {
            this.trigger("experienceStart", this.pl)
        }}, 0)







        this.setLoaders()


        this.startLoading()
    }

    setLoaders()
    {
        this.loaders = {}
        this.dracoLoader = new DRACOLoader()
        this.dracoLoader.setDecoderPath("./draco/")
        this.loaders.gltfLoader = new GLTFLoader()

        this.loaders.gltfLoader.setDRACOLoader(this.dracoLoader)
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
    }

    startLoading()
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file

        this.loaded++

        this.trigger("loading", [this.loaded, this.toLoad])
        gsap.to(this.pl, {progress: () => this.toLoad/this.loaded, ease:'linear'})

        if(this.loaded === this.toLoad)
        {
            this.trigger('ready')
        }
    }
}